/*global ViewController, WebView*/
var commentPopupController = new ViewController(
    {
        directory: "views/comment",
        name: "commentPopup",
        route: "comment-popup",
        openInPopup: true,
        noTitle: false,
        popup: {
            title: WebView.tr("comment.title"),
            size: "large"
        }
    }
);

commentPopupController.prepareDataOnEnter = function(data, callback){
    this.api.db.multiread({
        mail_message: { search: {model: data.model, res_id: data.id||0,  message_type: "comment"}, orderBy: "date desc", joinFetch: [
            { otherTable : "iz_user_list", name: "author", thisField: "author_id", otherField: "partner_id"},
            { otherTable : "mail_message_res_partner_rel", name: "recipients", type: "2many", joins: [
                { otherTable : "res_partner", name: "partner"},
            ]}
        ]},
    }, function(err, reads){
        if(err){ return callback(err) ;}

        reads.mail_message.forEach(function(msg){
            msg.recipients.forEach(function(rcp){
                if(rcp.partner && rcp.partner.id === this.api.currentUser.partner_id){
                    rcp.isCurrentUser = true;
                }
            }.bind(this));
        }.bind(this));

        callback(null,{
            id: data.id,
            model: data.model,
            comments: reads.mail_message,
            route: data.route
        }) ;
    }.bind(this));
} ;

commentPopupController.onDelete = function(ev){
    var comment = ev.data.data;
    this.view.confirm(WebView.tr("form.confirmDelete"), function(yes){
        if(yes){
            this.view.longTask(function(done){
                this.api.db.mail_message.remove(comment, function(err){
                    if(err){ return done(err) ;}
                    this.refresh(done) ;
                }.bind(this));
            }.bind(this));
        }
    }.bind(this)) ;
};

commentPopupController.onValidEdit = function(ev){
    ev.source.updateData() ;
    var comment = ev.source.getBoundObject() ;
    this.view.longTask(function(done){
        if(!comment.body){
            return done(WebView.tr("comment.emptyNote")) ;
        }
        var records = [] ;
    
        records.push({
            table: "mail_message",
            action: "update",
            record: {
                id: comment.id,
                body: comment.body,
            }
        }) ;

        this.api.db.transactionalChanges(records, function(err){
            if(err){ return done(err) ;}
            this.refresh(done) ;
        }.bind(this)) ;
    }.bind(this)) ;
};

commentPopupController.onAlertMsg = function(ev){
    this.view.updateData() ;
    var dataCopy = JSON.parse(JSON.stringify(this.data)) ;
    
    var comment  = ev.data.data ; 
    this.view.longTask(function(done){
        
        var records = [] ;
    
        records.push({
            table: "mail_message",
            action: "update",
            record: {
                id: comment.id,
                iz_alert_msg: comment.iz_alert_msg,
            }
        }) ;

        this.api.db.transactionalChanges(records, function(err){
            if(err){ return done(err) ;}
            this.refresh(function(){
                Object.keys(dataCopy).forEach(function(k){
                    if(k !== "comments"){
                        this.data[k] = dataCopy[k] ;
                    }
                }.bind(this)) ;
                this.view.render() ;
                done() ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

commentPopupController.onSend = function(){
    this.view.longTask(function(done){
        this.view.updateData();
        if(!this.data.body){
            return done(WebView.tr("comment.emptyNote")) ;
        }

        this.api.db.multiread({
            ir_model_data: { searchFirst : {model : "mail.message.subtype", name: "mt_note"} }
        }, function(err, reads){
            if(err){ return done(err) ;}
            var records = [] ;
    
            records.push({
                table: "mail_message",
                action: "insert",
                record: {
                    date: new Date(),
                    message_type: "comment",
                    iz_alert_msg: this.data.iz_alert_msg,
                    body: this.data.body,
                    model: this.data.model,
                    res_id: this.data.id,
                    subtype_id: reads.ir_model_data.res_id,
                    author_id: this.api.currentUser.partner_id,
                    iz_screen: this.data.route
                }
            }) ;

            this.data.recipients_ids.forEach(function(recipientId) {
                records.push({
                    table: "mail_message_res_partner_rel",
                    action: "insert",
                    record: {
                        mail_message_id: "${mail_message.id}",
                        res_partner_id: recipientId
                    }
                }) ;
            }) ;

            this.api.db.transactionalChanges(records, function(err){
                if(err){ return done(err) ;}
                this.refresh(done) ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

module.exports = commentPopupController ;